import {DEPARTMENT} from "./department.enum";

export interface TrackData {
	payload: {
		response: {
			chat_settings?: Settings;
			oems?: string;
		}
		params: Record<string, any>;
	};
}

export interface PickupLine {
	payload: {
		pickup_line: string;
	};
}

export type FtcOfferKey = 'oem_offers' | 'dealer_offers' | 'dynamic_payments_offers';
export type FtcSettings = {
	website?: Record<FtcOfferKey, boolean>;
};

export interface Settings {
    gpt_settings: {
        human_chat_text: string;
        should_show_chat_with_human: boolean;
        department_selection: {
            is_enabled: boolean;
            urls: Record<DEPARTMENT, string | null>;
        };
        custom_client_name?: string | null;
    },
    logo_url: string | null;
    ftc?: FtcSettings;
}

export enum VIEW_MODE {
	NOTIFICATION = 'notification',
	WIDGET = 'widget',
}

export const REPORTING_IDENTIFIER = 'FullpathGpt';
